import { faroCoreApiClient } from "@api/core-api/core-api-utils";
import { useErrorHandlerContext } from "@context-providers/error-handler/error-handler-context";
import { LoadingScreen } from "@flat-ui";
import { useAppNavigation } from "@hooks/use-app-navigation";
import { useEffect } from "react";

/** Performs logout operation with showing a loading state */
export function Logout(): JSX.Element {
  const { navigateToLogin } = useAppNavigation();
  const { handleError } = useErrorHandlerContext();

  // Logout and navigate to login page
  useEffect(() => {
    async function logoutAndRedirect(): Promise<void> {
      try {
        await faroCoreApiClient.users.logoutUser();
        navigateToLogin();
      } catch (error) {
        handleError({
          id: `logoutUser-${Date.now().toString()}`,
          title:
            "An error occurred while logging out. Reload the page to try again.",
          error,
          uiType: "toast",
        });
      }
    }

    void logoutAndRedirect();
  }, [handleError, navigateToLogin]);

  return <LoadingScreen />;
}
